import React from 'react';

import NewsListItem from './NewsListItem';
import ListFromApi from '../ListFromApi';

function NewsPage() {
    return <ListFromApi url="/news"
        elementType={NewsListItem}
        errorMessage="A hírek letöltése sikertelen." />
}

export default NewsPage;